<template>
    <div class="app-container">

      <div class="head">
        <h2>Home</h2>
        <router-link to="/settings"
          tag="button"
          class="icon settings" 
          v-if="isLoggedIn">
          <svg class="bigger"><use xlink:href="@/assets/svg/symbols.svg#settings">
            <title>Settings</title>
          </use></svg>
        </router-link>
        <router-link to="/login" 
          v-if="!isLoggedIn" 
          class="icon logout"
          tag="button">
          <svg><use xlink:href="@/assets/svg/symbols.svg#logout">
            <title>Sign Out</title>
          </use></svg>
        </router-link>
        <button class="icon logout" @click="signOut()" v-if="isLoggedIn">
          <svg><use xlink:href="@/assets/svg/symbols.svg#logout">
            <title>Sign Out</title>
          </use></svg>
        </button> 
        <router-link to="/add-postcard" 
                     tag="button" 
                     :title="isLoggedIn ? 'Add a postcard' : 'You need to be logged into an account to add a postcard.'"
                     :event="isLoggedIn ? 'click' : ''" 
                     :class="isLoggedIn ? 'enabled' : 'disabled'"
        >Add Postcard</router-link>
      </div>

      <div class="content">
        <h1>Later, Steve</h1>
        <img alt="Steve Minitra" src="@/assets/steve-bw.png">
        <p>A collection of postcards sent to a few lucky people by the late great Steve Minatra.</p>
        <div class="postcards">
          <router-link to="/postcards/latest" tag="button">Latest</router-link>
          <router-link to="/postcards/earliest" tag="button">Earliest</router-link>
          <router-link to="/postcards/recent" tag="button">Recently Added</router-link>
          <router-link to="/postcards/random" tag="button">Random</router-link>
        </div>
        <p v-if="postcardCount > 0" class="postcard-count"><span class="count">{{postcardCount}}</span> postcards have been uploaded.</p>
      </div>

      <div class="loading-mask" v-if="isLoading"><span>{{loadingMessage}}</span></div>
      
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  let vm;
  export default {

    computed: {
      ...mapGetters('users', ['isLoggedIn'])
    },

    data() {
      return {
        isLoading: false,
        loadingMessage:'Signing Out...',
        postcardCount: 0
      }
    },

    watch: {
      '$store.state.users.userAuthenticating': (val, oldVal) => {
        console.log(`Home.watch($store.state.users.userAuthenticating) val [${val}] oldVal [${oldVal}]`);
        if (!val) {
          vm.init();
        }
      }
    },

    mounted() {
      console.log(`Home.mounted()`);
      if (!this.$store.state.users.userAuthenticating) {
        this.init();
      }
      vm = this;
    },

    methods: {

      init() {
        console.log(`Home.init()`);
        if (this.postcardCount == 0) {
          this.$store.dispatch('postcards/getPostcardCount')
            .then((stats) => this.postcardCount = stats.postcardCount)
            .catch(this.handleError)
        }
      },

      loadSettings() {
        console.log('Home.loadSettings()');
      },
      
      signOut() {
        console.log('Home.signOut()');
        this.isLoading = true;
        this.$store.dispatch('users/logoutUser')
          .then(() => {
            this.isLoading = false;
          })
          .catch(this.handleError)
      }, 

      handleError(err) {
        console.warn('Notebook.handleError()');
        console.dir(err);
        this.isLoading = false;
      }

    }

  }

</script>

<style lang="scss" scoped>
  .postcard-count {
    margin-top: 30px;
    font-size: large;
    color: #888888;
    .count {
      font-size: larger;
    }
  }
</style>